import { TARGETING_VALUE } from '../constants-types/HeatmapTargetingOptions';

export function isSinglePageSearch(selectedTargetingValue: TargetingValue): boolean {
  return (
    selectedTargetingValue === TARGETING_VALUE.SIMPLE ||
    selectedTargetingValue === TARGETING_VALUE.EXACT
  );
}
